<div class="ghost-elements-wrapper">
  <div class="ghost-elements" *ngFor="let i of nbElements">
    <div class="ghost-element-header"></div>
    <div class="ghost-element-body"></div>
  </div>
</div>
